export class EmailInUseError extends Error {
  constructor() {
    super("Provided email is in use.");
    this.name = "EmailInUseError";
  }
}
